import React from "react";
import PauseCircleOutlineRoundedIcon from "@mui/icons-material/PauseCircleOutlineRounded";
import PlayCircleOutlineRoundedIcon from "@mui/icons-material/PlayCircleOutlineRounded";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";

import { ConfirmPopUp } from "../../../../components/PopUp";
import type { ConfirmDetail } from "../../../../components/PopUp/confirmShared/types";
import { formatCurrency } from "../../../../utils";
import { StatusChangeModalProps } from "./types";

export const StatusChangeModal: React.FC<StatusChangeModalProps> = React.memo(
  ({ isOpen, liability, onClose, onConfirm }) => {
    const { name, institution, isActive, currentAmount, liabilityTypeName } =
      liability;

    const subtitle = [liabilityTypeName, institution]
      .filter(Boolean)
      .join(" · ");

    const detail: ConfirmDetail = {
      icon: <AccountBalanceRoundedIcon />,
      title: name,
      subtitle,
      amount: formatCurrency(currentAmount),
      amountVariant: "neutral",
    };

    const deactivateText =
      "It will be hidden from your active liabilities and excluded from totals by default. Payments and transactions stay intact, and you can reactivate any time.";
    const reactivateText =
      "It will return to your active liabilities list and be included in totals again. You can deactivate it later at any time.";

    const title = isActive ? `Deactivate ${name}?` : `Reactivate ${name}?`;
    const text = isActive ? deactivateText : reactivateText;
    const confirmLabel = isActive
      ? "Deactivate liability"
      : "Reactivate liability";
    const loadingLabel = isActive ? "Deactivating…" : "Reactivating…";
    const icon = isActive ? (
      <PauseCircleOutlineRoundedIcon />
    ) : (
      <PlayCircleOutlineRoundedIcon />
    );

    return (
      <ConfirmPopUp
        isOpen={isOpen}
        setIsOpen={onClose}
        tone="warning"
        icon={icon}
        title={title}
        text={text}
        details={detail}
        confirmLabel={confirmLabel}
        loadingLabel={loadingLabel}
        onConfirm={onConfirm}
      />
    );
  },
);

StatusChangeModal.displayName = "StatusChangeModal";
